import type { FunctionComponent } from 'react';

import { DictionaryText, type PlainDictionaryTextProps } from '../../dictionary/reactBindings/DictionaryText';
import { HelpTranslations } from '../helpTranslations';

export interface HelpTextProps extends PlainDictionaryTextProps {}

export const HelpText: FunctionComponent<HelpTextProps> = ({ ...rest }) => {
  return <DictionaryText service={HelpTranslations} {...rest} />;
};
